var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26699 0C5.93562 0 5.66699 0.268629 5.66699 0.6V1.4C5.66699 1.73137 5.93562 2 6.26699 2H9.06699C9.39836 2 9.66699 1.73137 9.66699 1.4V0.6C9.66699 0.268629 9.39836 0 9.06699 0H6.26699ZM0.666992 4C0.666992 3.44772 1.11471 3 1.66699 3H13.667C14.2193 3 14.667 3.44772 14.667 4V12C14.667 12.5523 14.2193 13 13.667 13H1.66699C1.11471 13 0.666992 12.5523 0.666992 12V4ZM5.66699 8C6.49574 8 7.16699 7.32875 7.16699 6.5C7.16699 5.67125 6.49574 5 5.66699 5C4.83824 5 4.16699 5.67125 4.16699 6.5C4.16699 7.32875 4.83824 8 5.66699 8ZM5.66699 8.75C4.66574 8.75 2.66699 9.2525 2.66699 10.25V11H8.66699V10.25C8.66699 9.2525 6.66824 8.75 5.66699 8.75ZM8.66699 5H12.667V6.4H8.66699V5ZM12.667 7.40002H9.66699V8.80002H12.667V7.40002Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.c051e5d4.svg";
export { ForwardRef as ReactComponent };